import { render, staticRenderFns } from "./popover-form-wrapper.vue?vue&type=template&id=326bd728"
import script from "./popover-form-wrapper.vue?vue&type=script&lang=js"
export * from "./popover-form-wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('326bd728')) {
      api.createRecord('326bd728', component.options)
    } else {
      api.reload('326bd728', component.options)
    }
    module.hot.accept("./popover-form-wrapper.vue?vue&type=template&id=326bd728", function () {
      api.rerender('326bd728', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/note/popover-form-wrapper.vue"
export default component.exports